import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, Badge, Button, Card, ConfirmAction, EmptyState, PageHeader, Spinner } from '../components/ui'

export default function Notifications() {
  const navigate = useNavigate()
  const location = useLocation()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [message, setMessage] = useState(location.state?.message || '')

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await adminApi.listNotifications()
      setItems(Array.isArray(data) ? data : data.data || [])
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  const remove = async (id) => {
    try {
      await adminApi.deleteNotification(id)
      setMessage('Notificação excluída.')
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  if (loading) return <Spinner />

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Comunicação" title="Notificações globais" description="Mensagens exibidas aos clientes do MAMControl." icon="fa-bell" actions={<Button icon="fa-plus" onClick={() => navigate('/notifications/new')}>Nova notificação</Button>} />
      {error && <Alert type="error">{error}</Alert>}
      {message && <Alert type="success">{message}</Alert>}
      <Card>
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className="mp-card-lift flex flex-wrap items-start justify-between gap-4 rounded-2xl border border-slate-200 p-4">
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-semibold">{n.title}</span>
                  {n.is_prioritary ? <Badge tone="warning">Prioritária</Badge> : null}
                  {!n.is_active ? <Badge tone="danger">Inativa</Badge> : <Badge tone="success">Ativa</Badge>}
                </div>
                <p className="mt-1 text-sm text-slate-600">{n.message}</p>
                <p className="mt-1 text-xs text-slate-400">
                  {n.created_at}
                  {n.expires_at ? ` · expira ${n.expires_at}` : ''}
                </p>
              </div>
              <div className="flex gap-1">
                <Button
                  variant="outline"
                  className="!px-2 !py-1 text-xs"
                  onClick={() => navigate(`/notifications/${n.id}/edit`)}
                >
                  Editar
                </Button>
                <ConfirmAction className="!px-2 !py-1 text-xs" onConfirm={() => remove(n.id)} />
              </div>
            </div>
          ))}
          {items.length === 0 && <EmptyState title="Nenhuma notificação cadastrada" icon="fa-bell-slash" />}
        </div>
      </Card>
    </div>
  )
}
